import { BrMessage } from '@govbr-ds/react-components';
import style from './mensagem.module.scss';
import { useEffect, useState } from 'react';
import { MessageStatus } from '@govbr-ds/react-components/dist/types/messages';

const DEZ_SEGUNDOS = 10000;

function Mensagem({
  chaveUnica,
  conteudo,
  tipo,
}: {
  chaveUnica: number;
  conteudo: string | undefined;
  tipo: MessageStatus;
}) {
  const [isMostrarMensagem, setIsMostrarMensagem] = useState(true);
  const tempoDeVida = DEZ_SEGUNDOS;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMostrarMensagem(false);
    }, tempoDeVida);

    return () => clearTimeout(timer);
  }, [tempoDeVida]);

  return isMostrarMensagem ? (
    <BrMessage
      className={style.mensagem}
      key={chaveUnica}
      category='message'
      status={tipo}
      closable={true}
      message={conteudo}
    ></BrMessage>
  ) : (
    <></>
  );
}

export default Mensagem;
